export default __webpack_public_path__ + "static/media/gallery_07.799210c0.jpg";